import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FgaService } from './fga.service';

@Directive({
  selector: '[appFga]'
})
export class FgaDirective implements OnInit {
  @Input('appFga') fgaConfig!: { featureId: string; action?: string };

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly fgaService: FgaService
  ) {}

  ngOnInit(): void {
    this.fgaService.getFgaDetails().subscribe(() => {
      this.updateView();
    });
  }

  private updateView(): void {
    console.info("Update View");
    this.viewContainer.clear();
    if (this.fgaService.hasAccess(this.fgaConfig.featureId, this.fgaConfig.action)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
